import { Location as AngularLocation } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { MessageWorkspaceDialogComponent } from './messages-workspace.dialog';

@Injectable({
  providedIn: 'root',
})
export class MessagesWorkspaceService {
  private location = inject(AngularLocation);
  private modalCtrl = inject(ModalController);
  private router = inject(Router);

  async open(options?: { compose?: boolean; onDismissBack?: boolean }) {
    const existingModal = await this.modalCtrl.getTop();
    if (existingModal) {
      return existingModal;
    }

    const modal = await this.modalCtrl.create({
      component: MessageWorkspaceDialogComponent,
      componentProps: {
        compose: options?.compose ?? false,
      },
      cssClass: ['workspace-modal', 'stack-modal'],
    });

    if (options?.onDismissBack) {
      modal.onDidDismiss().then(() => {
        if (this.router.url.startsWith('/worker/messages')) {
          if (window.history.length > 1) {
            this.location.back();
            return;
          }

          this.router.navigateByUrl('/home');
        }
      });
    }

    await modal.present();
    return modal;
  }
}
